import { usePageContent } from '../../hooks/usePageContent';
import useMeta from '../../hooks/useMeta';
import useTitle from '../../hooks/useTitle';
import styles from './index.module.css';

const AFLPage = () => {
  const { find, meta } = usePageContent('afl');
  const seo = meta?.seo;
  useTitle(seo?.title || 'AFL');
  useMeta(seo);
  const c = find('richText') || {};

  return (
    <div id="content">
      <div className="page-header">
        <div className="container">
          <h1 className="page-header__title">{c.pageTitle || 'AFL'}</h1>
        </div>
      </div>
      <div className="content-holder content-holder--indented">
        <div className={`rich-text ${styles.wrapper}`} dangerouslySetInnerHTML={{ __html: c.richTextHtml || '' }} />
      </div>
    </div>
  );
};

export default AFLPage;
